import { Grid, Typography, CardContent, Box, Link } from '@mui/material';
import { SvgIconProps as IMuiSvgIconProps } from '@mui/material/SvgIcon';
import MuiCard from '@mui/material/Card';
import { IComponentCss } from '@tap/mui-ui';

/*
*   Карточка сервиса
*/

export type IServiceCard = {
    title: string,
    description?: string,
    img: IMuiSvgIconProps,
    link: string,
}


const css: IComponentCss = {
    cardWrap: {
        height: '100%',
        display: 'flex',
        position: 'relative',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    card: {
        height: '100%',
        borderColor: '#E0E0E0',
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: 'rgba(119, 119, 119, 0.15)',
        },
    },
    titleWrap: {
        textAlign: 'left',
        marginTop: '10px',
        display: 'flex',
        alignItems: 'center',
        marginBottom: '12px',
        '& .MuiSvgIcon-root': {
            fontSize: '36px',
        },
    },
    title: {
        lineHeight: 1,
        marginLeft: 2,
    },
};


export function ServiceCard({
    title,
    description,
    img,
    link,
}: IServiceCard) {
    return (
        <Grid
            item
            xs={12}
            sm={6}
            md={6}
        >
            <Grid sx={css.cardWrap}>

                <MuiCard
                    sx={css.card}
                    variant='outlined'
                    href={link}
                    component={Link}
                >
                    <CardContent>

                        <Box sx={css.titleWrap}>
                            <>
                                {img}
                                <Typography
                                    sx={css.title}
                                    component='span'
                                    variant='h6'
                                >
                                    {title}
                                </Typography>
                            </>
                        </Box>

                        <Typography
                            variant='body1'
                            color='text.secondary'
                        >
                            {!!description && description}
                        </Typography>

                    </CardContent>
                </MuiCard>

            </Grid>
        </Grid>
    );
}